import { useTranslation } from 'react-i18next';

/**
 * `tarp` is non-null (`Boolean!`) on both Order and Cart in the schema, so
 * null/undefined here only happens if a caller omits the prop. Renders
 * nothing in that case rather than defaulting to "No", which would
 * misrepresent a value nobody actually supplied.
 */
export function TarpStatus({
  tarp,
}: Readonly<{ tarp: boolean | null | undefined }>) {
  const { t } = useTranslation('order');

  if (tarp == null) return null;

  return (
    <p data-testid="order-items-tarped" className="text-sm text-neut-600 mt-1">
      {t('order.tarped')}: {tarp ? t('order.yes') : t('order.no')}
    </p>
  );
}
